import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(authenticated)/betaling-instellen/")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard", search: { machtiging: "stap1" } });
  },
});
